import axios from 'axios';
import { API_PATH } from '../../../constants';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import actions from './actions';

const options = {
  name: 'activePeriods',
  baseType: 'ACTIVE_PERIODS',
  apiEndpoint: 'active_periods'
};

const defaultOperations = createMetadataAPIOperations(options);

const assignTeamMembership =
  ({ userId, groupId, possessed, time, comments }) =>
  dispatch => {
    const data = { possessed, group_id: groupId, time, comments };

    return axios.post(`${API_PATH}/users/${userId}/active_periods`, data).then(response => {
      if (response.data.length === 0) {
        // If the response is empty, it means that the all active periods have
        // been deleted
        dispatch(actions.clearActivePeriods(userId, groupId));
      } else {
        dispatch(actions.fetchSuccessful(response.data, { replace: true }));
      }
    });
  };

export default {
  ...defaultOperations,
  assignTeamMembership
};
